module.exports = __webpack_public_path__ + "images/corporate_buybacks_lp/under_arrow_107ad2763d45fad11395502f9258c8ab.png";